import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { afterLogin } from "@/lib/authDestination";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const code = new URLSearchParams(window.location.search).get("code");
    if (!code) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/google", { code, redirect_uri: window.location.origin + "/auth/google" });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/");
        navigate(afterLogin(res.data), { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="google-callback">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground animate-pulse">Signing you in</p>
    </div>
  );
}
